import { isValidSelectedStyleTab, productionDepartments, selectedStyleTabUrlKey } from "./data";

import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import StyleAttributes from "./Departments/StyleAttributes/StyleAttributes";
import FabricAndTrims from "./Departments/FabricAndTrims/FabricAndTrims";

const SelectedStyle = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const activeDepartment = useMemo(() => {
		const tabFromUrl = searchParams.get(selectedStyleTabUrlKey);
		return isValidSelectedStyleTab(tabFromUrl) ? tabFromUrl : productionDepartments.STYLE_ATTRIBUTES.key;
	}, [searchParams]);

	const handleDepartmentChange = (e, val) => {
		setSearchParams((prev) => {
			const next = new URLSearchParams(prev);
			next.set(selectedStyleTabUrlKey, val);
			return next;
		});
	};

	const tabComponents = [
		{
			...productionDepartments.STYLE_ATTRIBUTES,
			component: <StyleAttributes foreignKey={""} />,
		},
		{
			...productionDepartments.FABRIC_TRIMS,
			component: <FabricAndTrims isActive={activeDepartment === productionDepartments.FABRIC_TRIMS.key} />,
		},
	];
	let scroll = 600;
	const handleScroll = () => {
		if (scroll > 2300) scroll = 0;
		window.scrollTo({ top: scroll, behavior: "smooth" });
		scroll += 600;
	};
	return (
		<Box
			sx={{
				width: "100%",
				minHeight: "100%",
				bgcolor: "#f6f7fb",
				py: { xs: 1.5, md: 2.5 },
			}}
			position="relative">
			<Box
				sx={{
					width: "100%",
					maxWidth: 1600,
					mx: "auto",
					px: { xs: 1.25, sm: 2, md: 3 },
					boxSizing: " border-box",
				}}>
				<Box
					sx={{
						p: { xs: 1.25, md: 1.5 },
						borderRadius: 3,
						border: "1px solid rgba(0,0,0,0.08)",
						bgcolor: "#fff",
						boxShadow: "0 10px 28px rgba(15,23,42,0.05)",
						mb: 2,
						boxSizing: " border-box",
					}}>
					<Tabs
						value={activeDepartment}
						onChange={handleDepartmentChange}
						variant="scrollable"
						scrollButtons="auto"
						sx={{
							"& .MuiTab-root": {
								textTransform: "none",
								fontWeight: 700,
								minHeight: 44,
								fontSize: 13,
							},
							"& .MuiTabs-indicator": {
								height: 3,
								borderRadius: 999,
							},
						}}>
						{Object.keys(productionDepartments).map((row) => {
							return (
								<Tab
									key={productionDepartments[row].key}
									label={productionDepartments[row].name}
									value={productionDepartments[row].key}
								/>
							);
						})}
					</Tabs>
				</Box>

				<Box
					sx={{
						p: { xs: 1.25, md: 1.5 },
						borderRadius: 3,
						border: "1px solid rgba(0,0,0,0.08)",
						bgcolor: "#fff",
						boxShadow: "0 10px 28px rgba(15,23,42,0.05)",
					}}>
					{tabComponents?.map((row) => (
						<Box width="100%" margin="auto" key={row.key} display={row.key === activeDepartment ? "block" : "none"}>
							{row.component}
						</Box>
					))}
				</Box>
			</Box>
			<Fab
				size="small"
				color="primary"
				aria-label="add"
				sx={{ position: "fixed", right: "5%", bottom: "5%", boxShadow: "0 12px 24px rgba(0,0,0,0.18)" }}
				onClick={handleScroll}>
				<KeyboardArrowDown />
			</Fab>
		</Box>
	);
};

export default SelectedStyle;
